import hallwayCold from '../img/Polygon cold.svg';
import hallwayCold1 from '../img/Polygon cold1.svg';
import hallwayCold2 from '../img/Polygon cold2.svg';
import hallwayCold3 from '../img/Polygon cold3.svg';
import hallwayWarm from '../img/Polygon warm.svg';
import hallwayWarm1 from '../img/Polygon warm1.svg';
import hallwayWarm2 from '../img/Polygon warm2.svg';
import hallwayWarm3 from '../img/Polygon warm3.svg';
import extintor from '../img/extintor.svg';
import hidrante from '../img/hidrante.svg';
import sdu from '../img/PDU.svg';
import doorDHBottom from '../img/porta dupla.svg';

// Function to get the configurations of a piece
export default function GetPieceConfig (size) {
    switch (size) {
      // Racks
      case 'rack':
        // return { name: 'rack', width: '29.5px', height: '29.5px', color:'#f70' };
        return { name: 'rack', width: '28px', height: '81px', color:'#f70', border:'1px solid #0005' };
  
      // Hallway Type
      case 'hallway-warm':
        return { name: 'hallway-warm', width: '28px', height: '28px', img: hallwayWarm, backgroundColor: '#fff0'};
      case 'hallway-warm1':
        return { name: 'hallway-warm1', width: '28px', height: '28px', img: hallwayWarm1, backgroundColor: '#fff0'};
      case 'hallway-warm2':
        return { name: 'hallway-warm1', width: '28px', height: '28px', img: hallwayWarm2, backgroundColor: '#fff0'};
      case 'hallway-warm3':
        return { name: 'hallway-warm1', width: '28px', height: '28px', img: hallwayWarm3, backgroundColor: '#fff0'};
      case 'hallway-cold':
        return { name: 'hallway-cold', width: '28px', height: '28px', img: hallwayCold, backgroundColor: '#fff0'};
      case 'hallway-cold1':
        return { name: 'hallway-cold1', width: '28px', height: '28px', img: hallwayCold1, backgroundColor: '#fff0'};
      case 'hallway-cold2':
        return { name: 'hallway-cold2', width: '28px', height: '28px', img: hallwayCold2, backgroundColor: '#fff0'};
      case 'hallway-cold3':
        return { name: 'hallway-cold3', width: '28px', height: '28px', img: hallwayCold3, backgroundColor: '#fff0'};
  
      // Refrigeration Equipment
      case 'fancoil':
        return { name: 'fancoil', width: '30px', height: '32px', color: '#00FFFF'};
  
      // Electrical Equipment
      case 'equipment':
        return { name: 'equipment', width: '28px', height: '83px', color: '#285EB0', border:'1px solid #0005'};
      case 'rack-mda':
        return { name: 'rack-mda', width: '28px', height: '28px', color: '#FFFF00', border:'1px solid #0005' };
      case 'sdu':
        return { name: 'sdu', width: '29.5px', height: '29.5px', img: sdu, backgroundColor: '#F69400', border:'1px solid #0005'};
  
      // Doors
      case 'door-bottom':
        return { name: 'door-bottom', width: '78px', height: '29.5px', img: doorDHBottom, backgroundColor: '#fff0'};
  
      // Other
      case 'extinguisher':
        return { name: 'extinguisher', width: '38px', height: '38px', img: extintor, backgroundColor: '#fff0'};
      case 'hydrant':
        return { name: 'hydrant', width: '29px', height: '29px', img: hidrante, backgroundColor: '#fff0'};
      case 'empty-floor':
        return { name: 'empty-floor', width: '26.5px', height: '80px', color: '#FFCCFF', border:'2px dashed red' };
      case 'floor-glass':
        return { name: 'floor-glass', width: '27px', height: '27.5px', color: '#96D6F1', border:'1px solid #0005' };
      case 'coluna':
        return { name: 'coluna', width: '29.5px', height: '29.5px', color: '#0008' };
      case 'mobilia':
        return { name: 'mobilia', width: '29.5px', height: '29.5px', color: '#A27F5F' };

      // DEFAULT
      default:
        return { name: size, width: '29.5px', height: '29.5px', color: '#0005' };
    }
  };